import React from 'react'
import { Tabs, Form, Select, Input, Button, Checkbox, message ,Icon} from 'antd';
import Signed from "./Signed";
import Sign from "./Sign";
import { API_CONFIG } from '../../api/config'
import api from '../../api/api.js'
import CreateGroup from './CreateGroup'
import './register.less'

class Register extends React.Component {
    state = {
        disabled2: true,
        disabled3: true,
        key: '1',
        has_team:false,// 是否有团队
        isfocus: false
    }
    componentDidMount() {
        let url = decodeURIComponent( this.getQueryString('redirect_url'))
        if(url && url !== 'null') {
            sessionStorage.setItem('market_url', url )
        } 
        if(this.getQueryString('key') === '2'){
            const token = this.getCookie(API_CONFIG.cloud_token)
            console.log(token,'token', document.cookie)
            api.queryCompany({
                access_token:token 
            }).then(res => {
                if (res.content.has_team === 2 || !res.content.team.length) {
                    //无团队登录成功
                    message.error('您还没有创建企业，请先注册')
                } else if(res.content.has_team === 1 && res.content.team.length) {
                    // 有团队等于1
                    sessionStorage.setItem('team', JSON.stringify(res.content.team))
                    this.setState({key:'2', has_team: true})
                } 
            }).catch(err => {
                message.error('没有查询到企业')
            })
        }
    }

    getCookie(name) {
        let cookieArr = document.cookie.split(';')
        for(let item of cookieArr){
            if(item.split('=')[0].trim() === name){
                let token = item.split(name)[1]
                return token.slice(1, token.length)
            }
        }
    }

    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
          r=window.location.search.substr(1).match(reg);
        }else{
          r=this.props.location.search.substr(1).match(reg);
        }
        if (r != null) return unescape(r[2]);
        return null;
    }

    callback = (key) => {
        console.log(key);
        this.setState({key})
    }
    get_key=e=>{
        console.log(e);
        this.setState({key:e})
    }
    has_team=e=>{
        console.log(e);
        this.setState({key:'2',has_team:e})
    }
    
 
    render() {
        const { key } = this.state
        return (
        <div className='register'>
            <div className="left">
                <div className='header'>
                    <img src={require("./../../imgs/czy_logo.svg")} alt=''/>
                    {/* <span className='icon'>|</span>
                    <span>注册</span> */}
                </div>
                {/* <div 
                    className='right' 
                    style={{cursor:'pointer'}}
                    onClick={() => {
                        this.props.history.push('/login')
                    }}
                >立即登录</div> */}
                <div className='content'>
                {
                    key === '1' ?  <div className='topFont'> <span className='leftFont'>新用户注册</span> 
                     <span  className='rightFont' onClick={() => {
                        this.props.history.push('/login')
                    }}> 
                   <Icon type="left" />
                     账号登录</span></div>
                    :''
                } 
                {key === '1' ?  <Sign set_key={this.get_key}  has_team={this.has_team} history={this.props.history} /> : ''}
                {key === '2' ?  <Signed set_key={this.get_key} has_team={this.state.has_team} history={this.props.history} />  : ''}
                {key === '3' ?  <CreateGroup set_key={this.get_key} has_team={this.state.has_team} history={this.props.history} /> : ''} 
                </div>
            </div>
            <div className='right'>
                <div className='font'>
                        <div >   <img src={require("./../../imgs/Service.png")} alt=''/></div>
                        <div className='toyourfamily'> <span className='to'>to</span> <span className='your'>your</span>  <span className='family' >family </span>  </div>
                        <div  className='Chinese'> 把社区服务做到家</div>
                </div>
            </div>
            <div className='footer'　>
                Copyright © 深圳市彩之云网络科技有限公司,All <span style={{color:'#fff'}}>Rights Reserved | 网站备案号：粤ICP备13038151号</span>
            </div>
        </div>)
    }
}
export default Form.create({})(Register)


// WEBPACK FOOTER //
// ./src/pages/register/register.jsx